import {Injectable} from "@angular/core";


@Injectable({providedIn: "root"})

export class RazmetkaService {
  constructor() {
  }

  public razmetka:any = [
    {
      category: {
        name: "Горизонтальная разметка",
        url: "gorizontalnaya",
        description: "Горизонтальная разметка (линии, стрелы, надписи и другие обозначения на проезжей части) устанавливает режимы и порядок движения либо содержит дополнительную информацию для участников дорожного движения."
      },
      seo: {
        title: "Горизонтальная разметка ПДД 2026 | ПДД",
        description: "Горизонтальная дорожная разметка ПДД 2026: виды линий, их значение и правила применения. Подробный разбор для подготовки к экзамену ГИБДД.",
        keywords: "горизонтальная разметка, ПДД разметка, дорожная разметка 2026, линии разметки, экзамен ГИБДД"
      },
      list: [
        {
          number: "1.1",
          images: ["1.1"],
          name: "Разделение встречных потоков",
          description: "Разделяет транспортные потоки противоположных направлений и обозначает границы полос движения в опасных местах."
        },
        {
          number: "1.2",
          images: ["1.2"],
          name: "Край проезжей части",
          description: "Обозначает край проезжей части или границы участков, на которые въезд запрещён."
        },
        {
          number: "1.3",
          images: ["1.3"],
          name: "Разделение потоков на многополосных дорогах",
          description: "Разделяет транспортные потоки противоположных направлений на дорогах с четырьмя и более полосами."
        },
        {
          number: "1.4",
          images: ["1.4"],
          name: "Остановка запрещена (жёлтая линия)",
          description: "Обозначает места, где запрещена остановка транспортных средств."
        },
        {
          number: "1.5",
          images: ["1.5"],
          name: "Разделение попутных и встречных потоков",
          description: "Разделяет транспортные потоки противоположных направлений на дорогах с несколькими полосами."
        },
        {
          number: "1.6",
          images: ["1.6"],
          name: "Предупреждающая линия приближения",
          description: "Предупреждает о приближении к сплошной линии разметки."
        },
        {
          number: "1.7",
          images: ["1.7"],
          name: "Полосы движения на перекрёстке / парковка",
          description: "Обозначает полосы движения в пределах перекрёстка или парковочную зону."
        },
        {
          number: "1.8",
          images: ["1.8"],
          name: "Полоса разгона и торможения",
          description: "Обозначает границу между полосой разгона/торможения и основной полосой."
        },
        {
          number: "1.9",
          images: ["1.9"],
          name: "Реверсивное движение",
          description: "Обозначает полосы с изменяемым направлением движения."
        },
        {
          number: "1.10",
          images: ["1.10"],
          name: "Стоянка запрещена (жёлтая линия)",
          description: "Обозначает места, где запрещена стоянка транспортных средств."
        },
        {
          number: "1.11",
          images: ["1.11"],
          name: "Прерывисто-сплошная линия",
          description: "Разделяет потоки и определяет правила перестроения и обгона."
        },
        {
          number: "1.12",
          images: ["1.12"],
          name: "Стоп-линия",
          description: "Указывает место обязательной остановки при сигнале светофора или знаке 2.5."
        },
        {
          number: "1.13",
          images: ["1.13"],
          name: "Уступите дорогу",
          description: "Указывает место, где водитель должен уступить дорогу."
        },
        {
          number: "1.14.1 - 1.14.2",
          images: ["1.14.1", "1.14.2"],
          name: "Пешеходный переход",
          description: "Обозначает пешеходный переход и направление движения пешеходов."
        },
        {
          number: "1.14.3",
          images: ["1.14.3"],
          name: "Диагональный пешеходный переход",
          description: "Обозначает диагональный пешеходный переход."
        },
        {
          number: "1.15",
          images: ["1.15"],
          name: "Велосипедный переход",
          description: "Обозначает пересечение велосипедной дорожки с проезжей частью."
        },
        {
          number: "1.16.1",
          images: ["1.16.1"],
          name: "Островок безопасности",
          description: "Разделяет транспортные потоки или отделяет парковку от велосипедных полос."
        },
        {
          number: "1.16.2",
          images: ["1.16.2"],
          name: "Разделение попутных потоков",
          description: "Разделяет транспортные потоки одного направления."
        },
        {
          number: "1.16.3",
          images: ["1.16.3"],
          name: "Зона слияния потоков",
          description: "Обозначает места слияния транспортных потоков."
        },
        {
          number: "1.17.1",
          images: ["1.17.1"],
          name: "Место остановки маршрутных ТС и такси",
          description: "Обозначает остановки общественного транспорта и такси."
        },
        {
          number: "1.17.2",
          images: ["1.17.2"],
          name: "Место остановки трамвая",
          description: "Обозначает остановку трамвая."
        },
        {
          number: "1.18",
          images: ["1.18"],
          name: "Направления движения по полосам",
          description: "Указывает разрешённые направления движения по полосам."
        },
        {
          number: "1.19",
          images: ["1.19"],
          name: "Сужение дороги",
          description: "Предупреждает о сужении проезжей части."
        },
        {
          number: "1.20",
          images: ["1.20"],
          name: "Приближение к стоп-линии",
          description: "Предупреждает о приближении к стоп-линии."
        },
        {
          number: "1.21",
          images: ["1.21"],
          name: "Приближение к знаку уступи дорогу",
          description: "Предупреждает о приближении к знаку 2.5."
        },
        {
          number: "1.22",
          images: ["1.22"],
          name: "Номер дороги",
          description: "Обозначает номер автомобильной дороги."
        },
        {
          number: "1.23.1",
          images: ["1.23.1"],
          name: "Полоса для маршрутных ТС",
          description: "Обозначает выделенную полосу для общественного транспорта."
        },
        {
          number: "1.23.2",
          images: ["1.23.2"],
          name: "Пешеходная дорожка / СИМ",
          description: "Обозначает пешеходную дорожку и движение СИМ и велосипедистов."
        },
        {
          number: "1.23.3",
          images: ["1.23.3"],
          name: "Велосипедная дорожка",
          description: "Обозначает велосипедную дорожку или полосу."
        },
        {
          number: "1.24.1",
          images: ["1.24.1"],
          name: "Дублирование предупреждающих знаков",
          description: "Дублирует предупреждающие дорожные знаки."
        },
        {
          number: "1.24.2",
          images: ["1.24.2"],
          name: "Дублирование запрещающих знаков",
          description: "Дублирует запрещающие знаки."
        },
        {
          number: "1.24.3",
          images: ["1.24.3"],
          name: "Инвалиды",
          description: "Дублирует знак парковки для инвалидов."
        },
        {
          number: "1.24.4",
          images: ["1.24.4"],
          name: "Фотовидеофиксация",
          description: "Обозначает участки возможной фотовидеофиксации."
        },
        {
          number: "1.24.5",
          images: ["1.24.5"],
          name: "Дублирование таблички 8.4.3.1",
          description: "Обозначает электромобили и гибриды."
        },
        {
          number: "1.24.6",
          name: "Велосипедная зона",
          description: "Дублирует знак велосипедной зоны."
        },
        {
          number: "1.24.7",
          name: "Дипломатическая парковка",
          description: "Дублирует знак парковки дипломатического корпуса."
        },
        {
          number: "1.25",
          images: ["1.25"],
          name: "Искусственная неровность",
          description: "Обозначает искусственные дорожные неровности."
        },
        {
          number: "1.26",
          images: ["1.26"],
          name: "Перекрёсток с затором",
          description: "Обозначает участок перекрёстка, на который нельзя выезжать при заторе."
        }
      ]
    },
    {
      category: {
        name: "Вертикальная разметка",
        url: "vertikalnaya",
        description: "Вертикальная разметка представляет собой сочетание черных и белых полос на дорожных сооружениях и элементах оборудования дорог. Она показывает габариты объектов и служит для зрительного ориентирования водителей."
      },
      seo: {
        title: "Вертикальная разметка ПДД 2026 | ПДД",
        description: "Вертикальная дорожная разметка ПДД 2026: обозначения на опорах, ограждениях и сооружениях, их значение и правила применения.",
        keywords: "вертикальная разметка, ПДД разметка, дорожная маркировка, черно-белая разметка, экзамен ГИБДД"
      },
      list: [
        {
          number: "2.1.1 - 2.1.3",
          images: ["2.1.1", "2.1.2", "2.1.3"],
          name: "Элементы дорожных сооружений",
          description: "Обозначают опоры мостов, путепроводов, торцевые части парапетов и другие опасные элементы дорожных сооружений."
        },
        {
          number: "2.2",
          images: ["2.2"],
          name: "Нижний край сооружений",
          description: "Обозначает нижний край пролетного строения тоннелей, мостов и путепроводов."
        },
        {
          number: "2.3",
          images: ["2.3"],
          name: "Тумбы на разделительных полосах",
          description: "Обозначает круглые тумбы, установленные на разделительных полосах или островках безопасности."
        },
        {
          number: "2.4",
          images: ["2.4"],
          name: "Направляющие элементы",
          description: "Обозначает направляющие столбики, надолбы, опоры ограждений и аналогичные элементы."
        },
        {
          number: "2.5",
          images: ["2.5"],
          name: "Ограждения на опасных участках",
          description: "Обозначает боковые поверхности ограждений на закруглениях малого радиуса, крутых спусках и опасных участках дорог."
        },
        {
          number: "2.6",
          images: ["2.6"],
          name: "Ограждения на обычных участках",
          description: "Обозначает боковые поверхности ограждений на остальных участках дорог."
        },
        {
          number: "2.7",
          images: ["2.7"],
          name: "Бордюры и островки безопасности",
          description: "Обозначает бордюры на опасных участках и возвышающиеся островки безопасности."
        }
      ]
    }

  ]

}
